/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import { SET_MANAGE_OPTIONS_LIST, SET_MANAGE_SELECTED_OPTION } from './manage.types';

export interface IManageSelectedOption {
    title: string;
    preview: string;
    isDisabled: boolean;
}

export const setManageOptionsListAction = (
    optionsList: Array<IManageSelectedOption>,
): TivoPayloadAction<{
    optionsList: Array<IManageSelectedOption>;
}> => ({
    type: SET_MANAGE_OPTIONS_LIST,
    payload: { optionsList },
});

export const setSelectedManageOption = (
    selectedOption: IManageSelectedOption,
): TivoPayloadAction<{ selectedOption: IManageSelectedOption }> => ({
    type: SET_MANAGE_SELECTED_OPTION,
    payload: { selectedOption },
});
